import { render, staticRenderFns } from "./yearView.vue?vue&type=template&id=74d367be"
import script from "./yearView.vue?vue&type=script&lang=js"
export * from "./yearView.vue?vue&type=script&lang=js"
import style0 from "./yearView.vue?vue&type=style&index=0&id=74d367be&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74d367be')) {
      api.createRecord('74d367be', component.options)
    } else {
      api.reload('74d367be', component.options)
    }
    module.hot.accept("./yearView.vue?vue&type=template&id=74d367be", function () {
      api.rerender('74d367be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/teacherMatch/yearView.vue"
export default component.exports